import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i7.1
import React from 'react';
import IconWrap from '../../IconWrap';
const FloatLeft = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M16 7h5a1 1 0 010 2h-5a1 1 0 010-2zM3 7h9a1 1 0 011 1v8a1 1 0 01-1 1H3a1 1 0 01-1-1V8a1 1 0 011-1zm18 10h-5a1 1 0 010-2h5a1 1 0 010 2zm0-4h-5a1 1 0 010-2h5a1 1 0 010 2zm0 8H3a1 1 0 010-2h18a1 1 0 010 2zm1-17a1 1 0 01-1 1H3a1 1 0 110-2h18a1 1 0 011 1z"
    })));
};
FloatLeft.displayName = 'FloatLeft';
export default FloatLeft;
